import { createAction } from 'redux-actions';
import * as actionTypes from './constants';

export const fetchWizardData =
  createAction(actionTypes.FETCH_ANNOUNCEMENT_WIZARD_DATA_REQUEST);
export const fetchWizardDataSuccess =
  createAction(actionTypes.FETCH_ANNOUNCEMENT_WIZARD_DATA_SUCCESS);
export const fetchWizardDataFailure =
  createAction(actionTypes.FETCH_ANNOUNCEMENT_WIZARD_DATA_FAILURE);

export const fetchAnnouncements = createAction(actionTypes.FETCH_ANNOUNCEMENTS_REQUEST);
export const fetchAnnouncementsSuccess = createAction(actionTypes.FETCH_ANNOUNCEMENTS_SUCCESS);
export const fetchAnnouncementsFailure = createAction(actionTypes.FETCH_ANNOUNCEMENTS_FAILURE);

export const fetchAnnouncement = createAction(actionTypes.FETCH_ANNOUNCEMENT_REQUEST);
export const fetchAnnouncementSuccess = createAction(actionTypes.FETCH_ANNOUNCEMENT_SUCCESS);
export const fetchAnnouncementFailure = createAction(actionTypes.FETCH_ANNOUNCEMENT_FAILURE);

export const addAnnouncement = createAction(actionTypes.ADD_ANNOUNCEMENT_REQUEST);
export const addAnnouncementSuccess = createAction(actionTypes.ADD_ANNOUNCEMENT_SUCCESS);
export const addAnnouncementFailure = createAction(actionTypes.ADD_ANNOUNCEMENT_FAILURE);

export const updateAnnouncement = createAction(actionTypes.UPDATE_ANNOUNCEMENT_REQUEST);
export const updateAnnouncementSuccess = createAction(actionTypes.UPDATE_ANNOUNCEMENT_SUCCESS);
export const updateAnnouncementFailure = createAction(actionTypes.UPDATE_ANNOUNCEMENT_FAILURE);

export const deleteAnnouncement = createAction(actionTypes.DELETE_ANNOUNCEMENT_REQUEST);
export const deleteAnnouncementSuccess = createAction(actionTypes.DELETE_ANNOUNCEMENT_SUCCESS);
export const deleteAnnouncementFailure = createAction(actionTypes.DELETE_ANNOUNCEMENT_FAILURE);

export const resetAnnouncementData = createAction(actionTypes.RESET_ANNOUNCEMENT_DATA);

export const fetchAnnouncementsFeed =
  createAction(actionTypes.FETCH_ANNOUNCEMENTS_FEED_REQUEST);
export const fetchAnnouncementsFeedSuccess =
  createAction(actionTypes.FETCH_ANNOUNCEMENTS_FEED_SUCCESS);
export const fetchAnnouncementsFeedFailure =
  createAction(actionTypes.FETCH_ANNOUNCEMENTS_FEED_FAILURE);

export const openAnnouncementsSidepanel =
  createAction(actionTypes.OPEN_ANNOUNCEMENTS_SIDEPANEL);
export const closeAnnouncementsSidepanel =
  createAction(actionTypes.CLOSE_ANNOUNCEMENTS_SIDEPANEL);

export const fetchBannerAnnouncement =
  createAction(actionTypes.FETCH_BANNER_ANNOUNCEMENT_REQUEST);
export const fetchBannerAnnouncementSuccess =
  createAction(actionTypes.FETCH_BANNER_ANNOUNCEMENT_SUCCESS);
export const fetchBannerAnnouncementFailure =
  createAction(actionTypes.FETCH_BANNER_ANNOUNCEMENT_FAILURE);
